<!--begin::Main-->
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
    <!--begin::Content wrapper-->
    <div class="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
            <!--begin::Toolbar container-->
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <!--begin::Page title-->
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <!--begin::Title-->
                    <div class="d-flex align-items-center">
                        <h1 class="page-heading"> 
                            <!-- <svg width="32" height="29" viewBox="0 0 32 29" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_82_1744)">
                                    <path
                                        d="M21.795 7.11531C19.8257 7.11531 18.2199 5.51738 18.2199 3.55766C18.2199 1.59793 19.8257 0 21.795 0C23.7643 0 25.3701 1.59793 25.3701 3.55766C25.3701 5.51738 23.7643 7.11531 21.795 7.11531ZM16.3112 4.58274C16.3112 2.05017 14.2509 0.0301492 11.7363 0.0301492C9.19127 0.0301492 7.16135 2.08032 7.16135 4.58274C7.16135 7.11531 9.22157 9.13533 11.7363 9.13533C14.2812 9.13533 16.3112 7.08516 16.3112 4.58274ZM27.0667 15.9491C27.5212 15.9491 27.8848 15.5572 27.8242 15.105C27.3394 11.6076 25.8245 8.1404 21.795 8.1404C19.5227 8.1404 18.0381 9.25593 17.0989 10.8539C17.7654 11.4267 18.3714 12.09 18.8561 12.904C19.4015 13.7784 19.8863 14.8035 20.2498 15.9793H27.0667V15.9491ZM4.01041 19.2053C3.91952 19.8686 4.43457 20.5017 5.13142 20.5017H18.3411C19.0379 20.5017 19.553 19.8987 19.4621 19.2053C18.7956 14.8035 16.8565 10.4619 11.7363 10.4619C6.61599 10.4619 4.67695 14.8035 4.01041 19.2053Z"
                                        fill="#265D91" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_82_1744" x="0" y="0" width="31.8308" height="28.5017"
                                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_82_1744" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_82_1744"
                                            result="shape" />
                                    </filter>
                                </defs>
                            </svg> -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-activity-icon lucide-activity"><path  d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" fill="#265D91"/></svg>
                            Nos offres d’emploi
                        </h1>
                        <!--begin::Menu-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Breadcrumb-->
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">
                            <a routerLink="/accueil" class="text-muted ">Accueil</a>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted"> <a class="text-muted "
                                routerLink="/offres-emploi/liste-offres-emploi"> Offre d’emploi </a></li>
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="text-muted bareme-updated"> {{state === 'update'?' Modifier':' Ajouter'}} barème</li>
                        <!--end::Item-->
                    </ul>
                    <!--end::Breadcrumb-->
                </div>
                <!--end::Page title-->
                <!--begin::Actions-->

                <!--end::Actions-->
            </div>
            <!--end::Toolbar container-->
        </div>
        <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class="card pt-15 pb-15">

                    <div class="container" [formGroup]="BaremeForm">
                        <div class="head">
                            <h4>Paramétrage du barème de sélection </h4>
                              <div class="tooltip-container tooltip-info">
                              <div class="tooltip-trigger">
                                <i class="fa-solid fa-circle-info" style="font-size: 20px"></i>
                              </div>
                              <div class="tooltip-content">
                                <div class="content">
                                  <h4>Ajoutez les critères de sélection et attribuez-leur un coefficient selon leur importance.</h4>
                                  <!-- <p>
                                    Ajoutez les critères de sélection et attribuez-leur un coefficient selon leur importance.
                                  </p> -->
                                </div>
                              </div>
                            </div>
                        </div>
                        <div class="info p-10">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="skill mb-5" formArrayName="skill_scores">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <label class="form-check-label " for="Comptétence">
                                                Comptétence
                                            </label>
                                            <div (click)="addSkills()">
                                                <img src="/assets/media/icons/icon-add.png" alt="addIcon" width="20"
                                                    class="addIcon">
                                            </div>
                                        </div>
                                        <div *ngFor="let skills of skillsControls; let i = index">
                                            <div class="row" [formGroupName]="i">
                                                <div class="col-lg-8">
                                                    <div class="input">
                                                        <ng-select [items]="skillsList" bindLabel="name_FR" [notFoundText]="'Aucun élément trouvé'"
                                                            class="form-select  mb-3" bindValue="id"
                                                            formControlName="skill_job_id" id="competences"
                                                            placeholder="compétences">
                                                        </ng-select>
                                                    </div>
                                                    <div *ngIf="skills.get('skill_job_id')?.hasError('duplicateSkill') && skills.get('skill_job_id')?.touched">
                                                        <small class="text-danger">Cette compétence est déjà sélectionnée.</small>
                                                      </div>
                                                </div>
                                                <div class="col-lg-4">
                                                    <div class="input">
                                                        <input type="number" name="number" id="number"
                                                            formControlName="coef" class="form-control mb-3"
                                                            placeholder="Coef" oninput="validity.valid||(value='1');" min="1">
                                                        <div (click)="removeSkills(i)"><img
                                                                src="/assets/media/icons/icon-delete.png" class="deleteIcon"
                                                                alt="deleteIcon" width="20"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="skill mb-5" formArrayName="experience_scores">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <label class="form-check-label " for="year_experience">
                                                Années expériences
                                            </label>
                                            <div 
                                            [ngClass]="{ 'disabled-icon-plus': BaremeForm.get('experience_scores')?.value?.length >= 5 }"
                                            (click)="BaremeForm.get('experience_scores')?.value?.length < 5 && addYearExp()">
                                                <img src="/assets/media/icons/icon-add.png" alt="addIcon" width="20" class="addIcon">
                                            </div>
                                        </div>
                                        <div *ngFor="let exp of yearExpControls; let i = index">
                                            <div class="row" [formGroupName]="i">
                                                <div class="col-lg-8">
                                                    <div class="input">
                                                        <ng-select [items]="expYears" bindLabel="name" [notFoundText]="'Aucun élément trouvé'"
                                                            class="form-select  mb-3" bindValue="name"
                                                            formControlName="year_experience" id="year_experience"
                                                            placeholder="Années expériences">
                                                        </ng-select>
                                                    </div>
                                                    <div *ngIf="exp.get('year_experience')?.hasError('duplicateYearExp') && exp.get('year_experience')?.touched">
                                                        <small class="text-danger">Ce nombre d'année d'expérience est déjà sélectionné.</small>
                                                      </div>
                                                </div>
                                                <div class="col-lg-4">
                                                    <div class="input">
                                                        <input type="number" id="coef" formControlName="coef" 
                                                            class="form-control mb-3" placeholder="Coef" oninput="validity.valid||(value='1');" min="1">
                                                        <div (click)="removeYearExp(i)"><img
                                                                src="/assets/media/icons/icon-delete.png" alt="deleteIcon"
                                                                width="20" class="deleteIcon"></div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="skill mb-5">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <label class="form-check-label" for="Score">
                                                Score
                                            </label>
                                            <div>

                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-8">
                                                <div class="input">
                                                    <input type="number" id="scoreQCM" class="form-control mb-3"
                                                        placeholder="100%" style="width: 100%;" disabled>
                                                </div>
                                            </div>
                                            <div class="col-lg-4">
                                                <div class="input">
                                                    <input type="number" id="test_qcm_score"
                                                        formControlName="test_qcm_score" class="form-control mb-3"
                                                        placeholder="Coef" oninput="validity.valid||(value='1');" min="1">
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                <div class="skill mb-5" formArrayName="language_scores">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <label class="form-check-label " for="Langue">
                                                Langue
                                            </label>
                                            <div [ngClass]="{ 'disabled-icon-plus': BaremeForm.get('language_scores')?.value?.length >= 5 }"
                                            (click)="BaremeForm.get('language_scores')?.value?.length < 5 && addLangues()">
                                                <img src="/assets/media/icons/icon-add.png" alt="addIcon" width="20"
                                                    class="addIcon">
                                            </div>
                                        </div>
                                        <div *ngFor="let langue of langueControls; let i = index">
                                            <div class="row" [formGroupName]="i">
                                                <div class="col-lg-8">
                                                    <div class="input">
                                                        <ng-select [items]="languages" bindLabel="name" [notFoundText]="'Aucun élément trouvé'"
                                                            class="form-select  mb-3" bindValue="name"
                                                            formControlName="language" id="language"
                                                            placeholder="Langue">
                                                        </ng-select>
                                                    </div>
                                                    <div *ngIf="langue.get('language')?.hasError('duplicatelanguage') && langue.get('language')?.touched">
                                                        <small class="text-danger">Ce language est déjà sélectionné.</small>
                                                      </div>
                                                </div>
                                                <div class="col-lg-4">
                                                    <div class="input">
                                                        <input type="number" id="coef" formControlName="coef" 
                                                            class="form-control mb-3" placeholder="Coef" oninput="validity.valid||(value='1');" min="1">
                                                        <div (click)="removeLangue(i)"><img
                                                                src="/assets/media/icons/icon-delete.png" alt="deleteIcon"
                                                                width="20" class="deleteIcon"></div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                </div>

                                </div>
                                <div class="col-lg-6">
                                    <div class="skill mb-5" formArrayName="availability_scores">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <label class="form-check-label " for="flexCheckDefault">
                                                Disponibilité
                                            </label>
                                            <div [ngClass]="{ 'disabled-icon-plus': BaremeForm.get('availability_scores')?.value?.length >= 6 }"
                                                (click)="BaremeForm.get('availability_scores')?.value?.length < 6 && addAvailability()">
                                                <img src="/assets/media/icons/icon-add.png" alt="addIcon" width="20"
                                                    class="addIcon">
                                            </div>
                                        </div>
                                        <div *ngFor="let availibility of availability_scoreControls; let i = index">
                                            <div class="row" [formGroupName]="i">
                                                <div class="col-lg-8">
                                                    <div class="input">
                                                        <ng-select [items]="disponibilite" class="form-select  mb-3" [notFoundText]="'Aucun élément trouvé'"
                                                            id="disponibilite" bindLabel="name" bindValue="id"
                                                            [placeholder]="'Disponibilité'" autoComplete
                                                            formControlName="availability">
                                                        </ng-select>
                                                    </div>
                                                    <div *ngIf="availibility.get('availability')?.hasError('duplicateavailability') && availibility.get('availability')?.touched">
                                                        <small class="text-danger">Cette Disponibilité est déjà sélectionnée.</small>
                                                      </div>
                                                </div>

                                                <div class="col-lg-4">
                                                    <div class="input">
                                                         <input type="number" id="coef" formControlName="coef" 
                                                            class="form-control mb-3" placeholder="Coef" oninput="validity.valid||(value='1');" min="1">
                                                        <div (click)="removeAvailability(i)"><img
                                                                src="/assets/media/icons/icon-delete.png" alt="deleteIcon"
                                                                width="20" class="deleteIcon"></div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container-btn px-10">
                            <button (click)="cancelScale()" class="wgu-btn wgu-cancel-btn">
                               Annuler
                            </button>
                            <button (click)="addBareme()" [disabled]="!isFormValid() || checkInputsDuplication()"
                              
                            matTooltipClass="custom-tooltip"
                            [matTooltip]="!isFormValid() ? 'Au moins un des paramètres du barème doit être rempli.' :
                              checkInputsDuplication() ? 'Les entrées sont dupliquées.' : ''" class="confirmer">
                                {{state === 'update'?'Modifier':'Enregistrer'}}
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>


<div class="modal fade" tabindex="-1" id="critere">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">Ajouter critère</h3>

                <!--begin::Close-->
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                    aria-label="Close">
                    <i class="ki-duotone ki-cross fs-1"><span class="path1"></span><span class="path2"></span></i>
                </div>
                <!--end::Close-->
            </div>

            <div class="modal-body">
                <form id="kt_customers_export_form" class="form" action="#">
                    <!--begin::Input group-->
                    <div class="fv-row mb-5">
                        <!--begin::Label-->
                        <div class="mb-5">
                            <label for="question" class="form-label">Nom critère</label>
                            <input type="text" class="form-control mb-3" placeholder="Nom du critère" />
                        </div>
                        <div class="mb-5">
                            <label for="score" class="form-label">score</label>
                            <input type="text" class="form-control mb-3" placeholder="score" />
                        </div>
                    </div>
                </form>

            </div>

            <div class="modal-footer">
                <button type="button" class="confirm">Confirmer</button>
            </div>
        </div>
    </div>
</div>
<ng-template #publier>
    <!-- <div class="modal fade" tabindex="-1" id="publier"> -->
        <!-- <div class="modal-dialog modal-dialog-centered"> -->
            <div class="modal-content" tabindex="-1" id="publier">  
                <div class="modal-header">
                    <h3 class="modal-title">Assigner un test pour cette offre d'emploi</h3>

                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" (click)="closeModalAndRedirect()">
                        <i class="ki-duotone ki-cross fs-1"><span class="path1"></span><span class="path2"></span></i>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="message mb-5">
                        <span>Ajouter un test de compétence</span>
                    </div>
                 
                    <div class="tests" *ngIf="addTestChecked">
                        <div class="form-check form-check-custom form-check-solid">
                            <input class="form-check-input" type="radio" [(ngModel)]="addTestWegestU" value="1"
                                id="flexRadioDefault1" />
                            <label class="form-check-label" for="flexRadioDefault1">
                                Test WeGestU
                            </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid">
                            <input class="form-check-input" type="radio" [(ngModel)]="addTest" value="2"
                                id="flexRadioDefault2" />
                            <label class="form-check-label" for="flexRadioDefault2">
                                Test Entreprise
                            </label>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                
                        <button type="button"(click)="closeModalAndRedirect()" class="btn btn-light">Annuler</button>
                   <button type="button"
                            [disabled]="!addTest && !addTestWegestU && !addTestChecked && !addScale"
                            class="btn btn-primary" (click)="onConfirm()">Confirmer</button>
                </div>
            </div>
        <!-- </div> -->
    <!-- </div> -->
</ng-template>